import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { loadMessages, locale } from 'devextreme/localization';
import ptMessages from 'devextreme/localization/messages/pt.json';
import notify from 'devextreme/ui/notify';
import { Curriculo } from 'src/app/shared/models/curriculo';
import { Ensino } from 'src/app/shared/models/ensino';
import { Estadocivil } from 'src/app/shared/models/estadocivil';
import { Estadouf } from 'src/app/shared/models/estadouf';
import { CepService } from 'src/app/shared/services/cep.service';
import { CurriculoService } from 'src/app/shared/services/curriculo.service';
import { EnsinoService } from 'src/app/shared/services/ensino.service';
import { EstadocivilService } from 'src/app/shared/services/estadocivil.service';
import { EstadoufService } from 'src/app/shared/services/estadouf.service';
import { VagaService } from 'src/app/shared/services/vaga.service';

@Component({
  selector: 'app-meucurriculo',
  templateUrl: './meucurriculo.component.html',
  styleUrls: ['./meucurriculo.component.scss']
})
export class MeucurriculoComponent implements OnInit {

  formModel!: Curriculo;
  ensinos!: Ensino[];
  estadoCivils!: Estadocivil[];
  estadoufs!: Estadouf[];

  constructor(
    private route: Router,
    private serviceCurriculo: CurriculoService,
    private serviceEnsino: EnsinoService,
    private serviceEstadocivil: EstadocivilService,
    private serviceEstadouf: EstadoufService,
    private serviceCep: CepService
  ) {
    this.formModel = new Curriculo;
    loadMessages(ptMessages);
    locale(navigator.language);
    this.setEmpregado = this.setEmpregado.bind(this);
    this.getCep = this.getCep.bind(this);

   }

  ngOnInit() {

    this.formModel.empregado = 'Não';
    this.formModel.empregadoF = false;

    this.getEnsinos();
    this.getEstadocivils();
    this.getEstadoufs();
    this.getCurriculo();

  }

  getCep(cep: any) {
    console.log(cep.value);
    this.serviceCep.getRegistro(cep.value).subscribe({
      next: (resposta: any) => {
        if(resposta.data.erro)
        {
          notify(`Falha na consulta do CEP  `, 'error', 3000);
          return;
        }
        this.formModel.endereco = resposta.data.logradouro;
        this.formModel.bairro = resposta.data.bairro;
        this.formModel.cidade = resposta.data.localidade;
        this.formModel.estado = resposta.data.uf;
        return;
      },
      error: (error: any) => {
        notify(`Falha na execuçaõ  ${error}`, 'error', 3000);
      }
    });
  }


  getEnsinos() {
    this.ensinos = this.serviceEnsino.getEnsinos();
  }

  getEstadocivils() {
    this.estadoCivils = this.serviceEstadocivil.getEstadocivils();
  }

  getEstadoufs() {
    this.estadoufs = this.serviceEstadouf.getEstadoufs();
  }

  setEmpregado(e: any) {
    if(this.formModel!=undefined)
    {
      this.formModel.empregado = (e.value === true) ? 'Sim' : 'Não';
    }
  }

  getCurriculo() {
    this.serviceCurriculo.getMeucurriculo().subscribe({
      next: (resposta: any) => {
        this.formModel = resposta.data;
        this.formModel.empregadoF = this.formModel.empregado === 'Sim';
      },
      error: (error: any) => {
        notify(`Falha na execuçaõ  ${error}`, 'error', 3000);
      }
    });
  }

  onClose() {
    this.route.navigate(['pages/curriculos']);
  }


  onSubmit(form: any, event: any) {
    const res = event.validationGroup.validate();
    if (res.isValid) {
      this.serviceCurriculo.onSalvar(form.formData).subscribe({
        next: (resposta: any) => {
          this.formModel = resposta.data;
          this.formModel.empregadoF = this.formModel.empregado === 'Sim';
          notify(`Cadastrado com sucesso`, 'success', 600);
        },
        error: (error: any) => {
          notify(`Falha na execuçaõ  ${error}`, 'error', 3000);
        }
      });
    } else {
      notify('Dados inválidos. Verifique!', 'error', 3000);
    }
  }

}
